/* "Email me this cart" (Oct 14 2026). See snippets/fha-cart-save.liquid.
   Subscribes the address to Klaviyo list Saved Cart and writes the cart to
   the profile, so flow TtRArb can send one email with a working link back.
   The link is a Shopify cart permalink (/cart/variant:qty,...), which rebuilds
   the cart on any device. ?storefront=true lands on the cart page; without it
   Shopify sends the link straight to Shop Pay checkout. */
(function () {
  if (customElements.get('fha-cart-save')) return;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function absolute(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  class FhaCartSave extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.note = this.querySelector('[data-note]');
      this.btn = this.querySelector('button');
      if (!this.form || this.form.dataset.bound) return;
      this.form.dataset.bound = '1';
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    say(text, kind) {
      this.note.textContent = text;
      this.note.className = 'fha-cart-save__note' + (kind ? ' fha-cart-save__note--' + kind : '');
    }

    onSubmit(e) {
      e.preventDefault();
      var input = this.form.querySelector('input[type=email]');
      var email = (input.value || '').trim();
      if (!EMAIL.test(email)) {
        this.say('Please check the email address.', 'err');
        input.focus();
        return;
      }
      this.btn.disabled = true;
      var self = this;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) throw new Error('empty cart');
          var first = cart.items[0];
          var more = cart.item_count - first.quantity;
          var props = {
            'FHA Saved Cart URL': 'https://freshhomeair.com/cart/' +
              cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(',') +
              '?storefront=true',
            'FHA Saved Cart Item': first.product_title + (more > 0 ? ' and ' + more + ' more' : ''),
            'FHA Saved Cart Total': money(cart.total_price),
            'FHA Saved Cart Image': absolute(first.image),
            'FHA Saved Cart At': new Date().toISOString()
          };
          try {
            window.klaviyo = window.klaviyo || [];
            window.klaviyo.push(['identify', Object.assign({ $email: email }, props)]);
          } catch (err) {}
          return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(self.dataset.company), {
            method: 'POST',
            headers: { 'content-type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'FHA Cart Save',
                  profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
                },
                relationships: { list: { data: { type: 'list', id: self.dataset.list } } }
              }
            })
          });
        })
        .then(function (res) {
          if (!res.ok) {
            return res.text().then(function (t) {
              try { console.error('[FHA cart save] Klaviyo subscribe failed', res.status, t); } catch (err) {}
              throw new Error('subscribe ' + res.status);
            });
          }
          self.form.querySelector('.fha-cart-save__row').hidden = true;
          self.say('Sent. Check your inbox for a link back to this cart.', 'ok');
        })
        .catch(function (err) {
          try { console.error('[FHA cart save]', err); } catch (e2) {}
          self.btn.disabled = false;
          self.say('That did not go through. Please try again in a moment.', 'err');
        });
    }
  }

  customElements.define('fha-cart-save', FhaCartSave);
})();
